<!--  -->
<template>
<div class='layout'>
    <div v-for="(item,i) in AllData" :key="i">
        <p class="title">{{item.id}}<span>{{item.name}}</span></p>
        <p>尺寸：{{item.size}}年代：{{item.date}}材质：{{item.nature}}类型：{{item.type}}级别：{{item.grade}}</p>
        <div class="model" >
            <img :src="`${$url}/${item.id}.jpg`" alt="">
            <iframe v-if="item.link"  :src="item.link" frameborder="0"></iframe>
        
        </div>
        <div class="imglist">
            <img v-for="(ele,j) in item.num" :src="`${$url}/${item.id}/${j + 1}.JPG`" alt="" :key="j">
        </div>
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    AllData:[]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    async getData() {
        let res = await this.$https({
          method: 'get',
          url: '/static/data.json',
        })

        this.AllData = res.list;
        
      },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    this.getData();
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .layout {
        display:flex;
        flex-wrap: wrap;
        justify-content: center;
        overflow:scroll !important;
        &>div {
            width:40%;
            margin:20px;
            border-bottom:1px solid #dcdcdc;
            border-right:1px solid #dcdcdc;
            .title {
                span {
                    margin-left:10px;
                    color:#e60012;
                }
            }
            iframe {
                width:100%;
                height:200px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/All/index.vue